







































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import RouteTranslations from "@/locales/routerTranslations";
import { Route } from 'vue-router';
import { configService, UtilitiesFunctions } from '@/helpers';
import { Suggestion } from '@/interfaces/suggestion';
import { acceptSuggestion, fetchSuggestions, SuggestionItem } from '@/helpers/requests/suggestions';
import i18n from '@/plugins/i18n';

@Component
export default class MenuManager extends Vue {
  translations: any = RouteTranslations;
  hideSlider = true;
  routeNames: string[] | null = null;
  privateSelection: string = "userData";
  searchTerm: string = '';
  loadingSuggestions: boolean = false;
  abortCtrl!: AbortController;
  suggestion: any = '';
  suggestionItems: SuggestionItem[] = [];

  @Prop({ default: [] }) private menuItems!: Array<any>;
  @Prop(String) private type!: string;
  @Prop(Boolean) private hideTabs!: boolean;


  @Watch('$route', { immediate: true, deep: true })
  onRouteChanged(route: Route) {
    if (route.name !== 'experiences') this.searchTerm = ''
    else if (this.searchTerm != this.$route.query.term) {
      this.searchTerm = this.$route.query.term as string;
      this.suggestionItems = [ {
        title: this.searchTerm,
        count: 0,
        type: 'experience-search',
        subtitle: this.$t('suggestions.searchExperiencesLabel') as string,
        key: `${this.searchTerm}-experience-search`,
        data: null
      }]
      this.suggestion = this.suggestionItems[0]
    }
  }

  @Watch('suggestion')
  onSuggestionAccepted(item: any) {
    acceptSuggestion(this.$router, item);
  }

  @Watch('searchTerm')
  onTermInput(input: string) {
    if (!input || input === this.suggestion.title) return;
    this.loadingSuggestions = true;
    this.suggestionItems = [];
    fetchSuggestions(input)
      .then(items => {
        this.loadingSuggestions = false;
        this.suggestionItems = items;
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        this.loadingSuggestions = false;
      })
  }

  onSearch() {
    this.$router.replace({
      name: 'experiences',
      query: { term: this.searchTerm }
    })
  }

  get selectedValue() {
    this.routeNames = this.menuItems.map(item => item.link);
    for (const [index, el] of this.routeNames.entries()) {
      if (this.$route.name === el) {
        return index;
      }
    }
    return "";
  }

  mounted() {
    switch (this.type) {
      case "tabs":
        this.hideSlider = false;
        break;
      case "text":
        this.hideSlider = true;
        break;
      default:
        this.hideSlider = true;
        break;
    }
  }

  handleClick(link: string, index: number) {
    if (link === "login") {
      this.$store
        .dispatch("app/setDialog", {
          type: "login",
          state: true
        })
        .then(() => {})
        .catch(error => {
          console.error(error);
        });
    } else if (link === "signup") {
      this.$store
        .dispatch("app/setDialog", {
          type: "signup",
          state: true
        })
        .then(() => {})
        .catch(error => {
          console.error(error);
        });
    } else if (link.includes("http")) {
      window.open(link, "_blank");
    } else if (link === "email") {
      location.href = "mailto:hello@divinea.com";
    } else {
      if (this.translations[this.$i18n.locale][link]) {
        const toRoute: string = this.translations[this.$i18n.locale][link].link;
        this.$router.push({ path: toRoute });
      }
    }
  }

  handlePrivateNav(item: any) {
    this.$emit("changePrivateMenu", item);
    this.privateSelection = item.link;
  }
}
